import i18n from 'modules/core/lib/i18n'

export type SalaryModalValidationData = {
  workplaceIds?: string[]
  type: 'range' | 'fixed'
  minAmount?: number
  maxAmount?: number
  grossSalary?: number
}

export type SalaryModalValidationIssue = {
  path: 'workplaceIds' | 'minAmount' | 'maxAmount' | 'grossSalary'
  message: string
}

export const getSalaryModalValidationIssues = (
  data: SalaryModalValidationData,
  workplacesMandatory: boolean
): SalaryModalValidationIssue[] => {
  const issues: SalaryModalValidationIssue[] = []

  if (workplacesMandatory && (!data.workplaceIds || data.workplaceIds.length === 0)) {
    issues.push({
      path: 'workplaceIds',
      message: i18n.t('job_catalog.nodes.salary_modal.errors.workplaces_required'),
    })
  }

  if (data.type === 'range') {
    if (data.minAmount == null) {
      issues.push({ path: 'minAmount', message: '' })
    }

    if (data.maxAmount == null) {
      issues.push({ path: 'maxAmount', message: '' })
    }

    if (data.minAmount != null && data.minAmount < 0) {
      issues.push({
        path: 'minAmount',
        message: i18n.t('job_catalog.nodes.salary_modal.errors.positive_value'),
      })
    }

    if (data.maxAmount != null && data.maxAmount < 0) {
      issues.push({
        path: 'maxAmount',
        message: i18n.t('job_catalog.nodes.salary_modal.errors.positive_value'),
      })
    }

    if (data.minAmount != null && data.maxAmount != null && data.maxAmount < data.minAmount) {
      issues.push({
        path: 'maxAmount',
        message: i18n.t('job_catalog.nodes.salary_modal.errors.max_lower_than_min'),
      })
    }
  }

  if (data.type === 'fixed') {
    if (data.grossSalary == null) {
      issues.push({ path: 'grossSalary', message: '' })
    }

    if (data.grossSalary != null && data.grossSalary < 0) {
      issues.push({
        path: 'grossSalary',
        message: i18n.t('job_catalog.nodes.salary_modal.errors.positive_value'),
      })
    }
  }

  return issues
}
